import React from 'react';

/**
 * Casella di selezione nativa.
 *
 * E il caso piu netto del repository: 52 caselle con className statica
 * usano appena 3 varianti, e 50 condividono la stessa identica base
 * (h-4 w-4 text-blue-600 border-gray-300 rounded). Le 14 che aggiungono
 * mt-1 lo fanno come prefisso puramente additivo, senza sovrascrivere
 * nulla: passano da className e non generano conflitti.
 *
 * type="checkbox" e applicato dopo lo spread perche definisce l'identita
 * del componente e non deve poter essere cambiato dal chiamante. Tutte le
 * altre props (checked, onChange, disabled, name, aria-*) sono inoltrate
 * invariate: comportamento, eventi e accessibilita restano quelli
 * dell'elemento nativo.
 *
 * text-primary = text-blue-600 | border-line-strong = border-gray-300
 */
export default function Checkbox({ className = '', ...props }) {
  return (
    <input
      {...props}
      type="checkbox"
      className={`h-4 w-4 rounded border-line-strong text-primary ${className}`.trim()}
    />
  );
}
